import { QueryFunctionContext } from '@tanstack/react-query'
import anklePatrolAxios from '../../../services/config/axiosClient'
import { webContactApiRoutes } from './apiRoutes'

export const webTicketList = ({ queryKey }: QueryFunctionContext) =>
  anklePatrolAxios.get(
    `${webContactApiRoutes.webTicketList}?limit=${queryKey?.[2]}&page=${queryKey?.[1]}`,
  )

export const markWebTicketRead = (payload: { contactId: string }) =>
  anklePatrolAxios.put(webContactApiRoutes.markWebTicketRead, payload)
